import { render } from "./BannerItem.vue?vue&type=template&id=b5fd3d2c&scoped=true&ts=true"
import script from "./BannerItem.vue?vue&type=script&lang=ts"
export * from "./BannerItem.vue?vue&type=script&lang=ts"

import "./BannerItem.vue?vue&type=style&index=0&id=b5fd3d2c&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fd3d2c"]])

export default __exports__